import { ACTIVITIES_GET, ACTIVITY_GET } from './reduxConstant';
import { createReducer } from '../../../../App/common/utilities/reducerUtils';

const initialState = {
  total: 0,
  search: {
    currentPage: '',
    searchText: '',
    itemPerPage: '',
  },
  items: [],
};

const activitiesGet = (state, payload) => {
  let total = payload?.activities?.total ?? state.total;
  let items = payload?.activities?.items;
  
  return {
    ...state,
    total: total,
    items: items,
  };
};

const activityGet = (state, payload) => {
  return {
    ...state,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.activity.id + ''),
      payload.activity,
    ],
  };
};

export default createReducer(initialState, {
  [ACTIVITIES_GET]: activitiesGet,
  [ACTIVITY_GET]: activityGet,
});
